import { useStore } from "./store";
import { useEffect } from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
// Routes
import Routes from "./routes";
//Toastify
import "react-toastify/dist/ReactToastify.css";
import ToastContainer from "./components/Toast/ToastContainer/ToastContainer";
//Amplitude
import * as amplitude from "@amplitude/analytics-browser";
import { sessionReplayPlugin } from "@amplitude/plugin-session-replay-browser";

export const browserRouter = createBrowserRouter([
  { path: "*", element: <Routes /> },
]);

function App() {
  const { fieldRoutesCustomer } = useStore();
  const sessionReplayTracking = sessionReplayPlugin();
  amplitude.add(sessionReplayTracking);

  amplitude.init(process.env.REACT_APP_AMPLITUDE_API_KEY, {
    autocapture: false,
  });

  useEffect(() => {
    if (fieldRoutesCustomer) {
      amplitude.setUserId(fieldRoutesCustomer?.customerID);
    } else {
      amplitude.setUserId(undefined);
    }
  }, [fieldRoutesCustomer]);

  useEffect(() => {
    const hubspotScript = document.createElement("script");

    hubspotScript.src = "https://js.hs-scripts.com/46128459.js";
    hubspotScript.async = true;
    hubspotScript.defer = true;

    document.body.appendChild(hubspotScript);
  }, []);

  return (
    <>
      <RouterProvider router={browserRouter} />
      <ToastContainer />
    </>
  );
}

export default App;
